import { Flex, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PropertyCardContext } from 'src/components/cards/property/property-card.context'
import { CONDO_REGEX, IPTU_REGEX } from 'src/constants'
import { convertToMoney } from 'src/utils/monetary'

import SmallDotIcon from '../../../icons/small-dot.icon'

const MonthlyPrice = () => {
  const { property } = React.useContext(PropertyCardContext)
  const { t } = useTranslation('home-v2')
  const iptu = property?.price?.monthly?.fees.find(
    (fee: any) => IPTU_REGEX.test(fee.name) || IPTU_REGEX.test(fee.name.pt_BR)
  )

  const condo = property?.price?.monthly?.fees.find(
    (fee: any) => CONDO_REGEX.test(fee.name) || CONDO_REGEX.test(fee.name.pt_BR)
  )

  const isUnavailable = property?.price?.monthly?.netAmount.amount === 0

  const hasIptu = iptu?.amount.amount !== 0 && !!iptu?.amount
  const hasCondo = condo?.amount.amount !== 0 && !!condo?.amount

  return (
    <Flex direction="column" cursor="pointer">
      <Flex gap="6px">
        <Text fontSize="14px"> {t('home-v2:PRODUCTS.rent')}</Text>
        <Text
          textDecor={isUnavailable ? 'line-through' : 'none'}
          fontWeight="bold"
          fontSize="14px"
        >
          {convertToMoney(property?.price?.monthly?.netAmount)}
        </Text>
      </Flex>

      <Flex gap="8px" alignItems="center">
        <Flex gap="6px">
          <Text fontSize="12px" color="black.300">
            {t('home-v2:PRODUCTS.condo')}
          </Text>
          <Text textDecor={hasCondo ? 'none' : 'line-through'} fontSize="12px">
            {convertToMoney(condo?.amount)}
          </Text>
        </Flex>

        <SmallDotIcon />

        <Flex gap="6px">
          <Text fontSize="12px" color="black.300">
            {t('home-v2:PRODUCTS.iptu')}
          </Text>
          <Text textDecor={hasIptu ? 'none' : 'line-through'} fontSize="12px">
            {convertToMoney(iptu?.amount)}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default MonthlyPrice
